export type AccountSettingsPasswordFormInputs = {
  currentPassword: string;
  newPassword: string;
};

export enum ACCOUNT_SETTINGS_PASSWORD_FORM_FIELDS {
  CURRENT_PASSWORD_FIELD = 'currentPassword',
  NEW_PASSWORD_FIELD = 'newPassword',
}
